import { monteurApi } from '../common/monteur-api';
export var workOrderImportsApi = monteurApi
    .enhanceEndpoints({
    addTagTypes: ['WorkOrderImports']
})
    .injectEndpoints({
    endpoints: function (builder) { return ({
        getPaginatedWorkOrderImports: builder.query({
            query: function (query) { return ({
                url: "WorkOrderImport/get-paginated?page=".concat(query.page, "&pageSize=").concat(query.pageSize),
                method: 'GET'
            }); },
            providesTags: ['WorkOrderImports']
        })
    }); }
});
export var useGetPaginatedWorkOrderImportsQuery = workOrderImportsApi.useGetPaginatedWorkOrderImportsQuery;
